"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _componentProperties = _interopRequireDefault(require("@/utils/componentProperties"));
var _leftConfigPage = _interopRequireDefault(require("./leftConfigPage.vue"));
var _headTop = _interopRequireDefault(require("../component/headTop.vue"));
var _phoneBottom = _interopRequireDefault(require("../component/phoneBottom.vue"));
var _zdyPage = _interopRequireDefault(require("../../../utils/zdyPage.js"));
var _configPage = require("@/api/zdyPage/configPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 组件数据
var _default = exports.default = {
  name: 'ConfigPage',
  components: {
    leftConfigPage: _leftConfigPage.default,
    utils: _zdyPage.default,
    headTop: _headTop.default,
    phoneBottom: _phoneBottom.default,
    componentProperties: _componentProperties.default
  },
  created: function created() {
    // 接收参数
    var id = this.$route.query.id;
    var copyFrom = this.$route.query.copyFrom;
    if (id) {
      // 编辑模式：带上 id，保存时更新原记录
      this.id = id;
      this.configInfoData(id);
    } else if (copyFrom) {
      // 复制模式：拉取源数据回显，但不绑定 id，保存即新建
      this.id = '';
      this.configInfoData(copyFrom, true);
    }
  },
  mounted: function mounted() {
    this.pageSetup.name = '页面标题';
    this.currentproperties = this.pageSetup;
    this.title = '页面设置';
  },
  data: function data() {
    return {
      realTimeView: {
        show: false // 是否显示预览
      },
      resPath: process.env.VUE_APP_IMAGE_PATH || '',
      id: '',
      deleShow: true,
      //删除标签显示
      index: '',
      //当前选中的index
      rightcom: 'decorate',
      //右侧组件切换
      title: '',
      //标题
      currentproperties: {},
      //当前属性
      pageSetup: {
        // 页面设置属性
        name: '页面标题',
        //页面名称
        details: '',
        //页面描述
        type: '',
        // 类型 1主页 2默认页
        pageIndex: '',
        // 页面标识
        backgroundColor: 'rgba(249, 249, 249, 10)',
        //背景颜色
        backgroundImg: '',
        // 背景图片
        pageUrl: '' // 页面地址
      },
      pageComponents: [],
      //页面组件
      offsetY: 0,
      //记录上一次距离父元素高度
      pointer: {
        show: false
      },
      //穿透
      onlyOne: ['1-10', '1-16'],
      // 只能存在一个的组件(组件的type，1-10 悬浮按钮、1-16 底部导航)
      componentCounter: 0 // 组件编号计数器
    };
  },
  computed: {
    // 右侧动态组件的 key：选中相同类型组件时强制重建实例，
    // 避免子组件 created 钩子不重新触发导致的设置面板数据不切换问题
    panelKey: function panelKey() {
      return this.rightcom + '-' + this.index;
    }
  },
  watch: {
    /* 监听右侧属性设置切换 */rightcom: function rightcom(newval) {
      if (newval === 'decorate') {
        _zdyPage.default.forEach(this.pageComponents, function (res) {
          /* 修改选中 */
          if (res.active === true) res.active = false;
        });
        this.currentproperties = this.pageSetup;
        this.title = '页面设置';
        return;
      }
      if (newval === 'componenmanagement') {
        /* 替换 */
        _zdyPage.default.forEach(this.pageComponents, function (res) {
          /* 修改选中 */
          if (res.active === true) res.active = false;
        });
        this.currentproperties = this.pageComponents;
        this.title = '组件管理';
      }
    }
  },
  methods: {
    saveDraft: function saveDraft(status) {
      var _this = this;
      // 验证页面地址是否有值
      // if (this.pageSetup.type === '2' && !this.pageSetup.pageUrl) {
      //   this.$message.error('请填写指向页面地址')
      //   return
      // }
      this.pageSetup.pageUrl = '/pages/customPageConfiguration/index';
      var data = {
        id: this.id,
        name: this.pageSetup.name,
        details: this.pageSetup.details,
        type: this.pageSetup.type,
        pageIndex: this.pageSetup.pageIndex,
        backgroundColor: this.pageSetup.backgroundColor,
        backgroundImg: this.pageSetup.backgroundImg,
        json: JSON.stringify(this.pageComponents),
        urlLink: this.pageSetup.pageUrl,
        enable: status
      };
      (0, _configPage.saveConfigPage)(data).then(function (res) {
        if (res.code === 200) {
          _this.$message.success('保存成功');
          _this.$router.go(-1);
        } else {
          _this.$message.error('保存失败' + res.message);
        }
      }).catch(function (err) {
        console.log(err);
        _this.$message.error('保存失败' + (err && err.message ? err.message : ''));
      });
    },
    configInfoData: function configInfoData(id) {
      var _this2 = this;
      var isCopy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      console.log("详情接口 查询 ");
      (0, _configPage.getConfigPageInfo)(id).then(function (res) {
        console.log(res);
        if (res.code === 200) {
          _this2.pageSetup.name = res.data.name;
          _this2.pageSetup.details = res.data.details;
          _this2.pageSetup.type = String(res.data.type) || '';
          _this2.pageSetup.pageIndex = res.data.pageIndex;
          _this2.pageSetup.backgroundColor = res.data.backgroundColor;
          _this2.pageSetup.backgroundImg = res.data.backgroundImg;
          _this2.pageSetup.pageUrl = res.data.urlLink;
          _this2.pageComponents = JSON.parse(res.data.json);
          // 初始化组件编号计数器，确保与现有组件数量匹配
          _this2.componentCounter = _this2.pageComponents.length;

          // 复制模式：名称加后缀，清空 pageIndex 避免冲突，由用户重新填写
          if (isCopy) {
            _this2.pageSetup.name = (res.data.name || '') + '-副本';
            _this2.pageSetup.pageIndex = '';
          }
        }
      });
    },
    goBack: function goBack() {
      // 返回到管理页面
      this.$router.go(-1);
    },
    /**
     * 当将元素或文本选择拖动到有效放置目标（每几百毫秒）上时，会触发此事件
     *
     * @param {Object} event event对象
     */
    allowDrop: function allowDrop(event) {
      //阻止浏览器的默认事件
      event.preventDefault();

      /* 获取鼠标高度 */
      var eventoffset = event.offsetY;

      /* 如果没有移动不触发事件减少损耗 */
      if (this.offsetY === eventoffset) return;else this.offsetY = eventoffset;

      /* 获取组件 */
      var childrenObject = event.currentTarget.children[0];
      // 一个以上的组件计算
      if (this.pageComponents.length) {
        /* 如果只有一个组件并且第一个是提示组件直接返回 */
        if (this.pageComponents.length === 1 && this.pageComponents[0].type === 0) return;

        /* 如果鼠标的高度小于第一个的一半直接放到第一个 */
        if (eventoffset < childrenObject.children[0].clientHeight / 2) {
          /* 如果第一个是提示组件直接返回 */
          if (this.pageComponents[0].type === 0) return;

          /* 删除提示组件 */
          this.pageComponents = this.pageComponents.filter(function (res) {
            return res.component !== 'placementarea';
          });

          /* 最后面添加提示组件 */
          this.pageComponents.unshift({
            component: 'placementarea',
            type: 0
          });
          return;
        }
        /* 记录距离父元素高度 */
        var childOff = childrenObject.offsetTop;

        /* 鼠标在所有组件下面 */
        if (eventoffset > childrenObject.clientHeight || childrenObject.lastChild.offsetTop - childOff + childrenObject.lastChild.clientHeight / 2 < eventoffset) {
          /* 最后一个组件是提示组件返回 */
          if (this.pageComponents[this.pageComponents.length - 1].type === 0) {
            return;
          }

          /* 末尾是悬浮按钮时禁止再往后插入（悬浮按钮固定在最底部） */
          if (this.pageComponents[this.pageComponents.length - 1].type === '1-10') {
            return;
          }

          /* 清除提示组件 */
          this.pageComponents = this.pageComponents.filter(function (res) {
            return res.component !== 'placementarea';
          });

          /* 最后一个不是提示组件添加 */
          this.pageComponents.push({
            component: 'placementarea',
            type: 0
          });
          return;
        }
        var childrens = childrenObject.children;

        /* 在两个组件中间，插入 */
        for (var i = 0, l = childrens.length; i < l; i++) {
          var childoffset = childrens[i].offsetTop - childOff;
          if (childoffset + childrens[i].clientHeight / 2 > event.offsetY) {
            /* 如果是提示组件直接返回 */
            if (this.pageComponents[i].type === 0) break;
            if (this.pageComponents[i - 1].type === 0) break;

            /* 清除提示组件 */
            this.pageComponents = this.pageComponents.filter(function (res) {
              return res.component !== 'placementarea';
            });
            this.pageComponents.splice(i, 0, {
              component: 'placementarea',
              type: 0
            });
            break;
          } else if (childoffset + childrens[i].clientHeight > event.offsetY) {
            if (this.pageComponents[i].type === 0) break;
            if (!this.pageComponents[i + 1] || this.pageComponents[i + 1].type === 0) break;
            this.pageComponents = this.pageComponents.filter(function (res) {
              return res.component !== 'placementarea';
            });
            this.pageComponents.splice(i, 0, {
              component: 'placementarea',
              type: 0
            });
            break;
          }
        }
      } else {
        /* 一个组件都没有直接push */
        this.pageComponents.push({
          component: 'placementarea',
          type: 0
        });
      }
    },
    /**
     * 当在有效放置目标上放置元素或选择文本时触发此事件
     *
     * @param {Object} event event对象
     */
    drop: function drop(event) {
      var _this3 = this;
      /* 获取数据 */
      var data = _zdyPage.default.deepClone(_componentProperties.default.get(event.dataTransfer.getData('componentName')));

      // 防御：拖入来源不是左侧合法组件时（data-name 为 undefined/空/未知名），
      // componentProperties.get 会返回 undefined，此时直接清理并中止
      if (!data || !data.component) {
        this.dragleaves();
        return;
      }

      // 为新组件添加唯一编号
      this.componentCounter++;
      data.componentNumber = data.component + '-' + this.componentCounter;

      /* 查询是否只能存在一个的组件且在第一个（悬浮按钮 1-10 例外，可放第一个） */
      var someOne = this.pageComponents.some(function (item, index) {
        return item.component === 'placementarea' && index === 0 && _this3.onlyOne.includes(data.type) && data.type !== '1-10';
      });
      if (someOne) {
        this.$message.info('固定位置的组件(如: 底部导航)不能放在第一个!');
        /* 删除提示组件 */
        this.dragleaves();
        return;
      }

      /* 查询是否只能存在一个的组件 */
      var someResult = this.pageComponents.some(function (item) {
        return _this3.onlyOne.includes(item.type) && item.component === event.dataTransfer.getData('componentName');
      });
      if (someResult) {
        this.$message.info('当前组件只能添加一个!');
        /* 删除提示组件 */
        this.dragleaves();
        return;
      }

      /* 悬浮按钮：固定放在最末尾，且不参与拖拽排序 */
      if (data.type === '1-10') {
        /* 清除提示组件 */
        this.dragleaves();
        /* 取消其它组件选中 */
        _zdyPage.default.forEach(this.pageComponents, function (res) {
          if (res.active === true) res.active = false;
        });
        /* 追加到末尾 */
        this.pageComponents.push(data);
        this.index = this.pageComponents.length - 1;
        /* 切换右侧属性面板 */
        this.rightcom = data.style;
        this.currentproperties = data.setStyle;
        this.title = data.text;
        return;
      }

      /* 替换 */
      _zdyPage.default.forEach(this.pageComponents, function (res, index) {
        /* 修改选中 */
        if (res.active === true) res.active = false;
        /* 替换提示 */
        _this3.index = index;
        if (res.component === 'placementarea') _this3.$set(_this3.pageComponents, index, data);
      });

      /* 悬浮按钮固定在最底部：新增其它组件后若它不在末尾则下沉 */
      this.ensureFloatingAtEnd();

      /* 切换组件 */
      this.rightcom = data.style;
      /* 丢样式 */
      this.currentproperties = data.setStyle;
      /* 同步标题给右侧面板 */
      this.title = data.text;
      console.log(data, this.rightcom, this.currentproperties, '----------components data');
    },
    /**
     * 保证悬浮按钮（type '1-10'）始终位于 pageComponents 最末尾。
     * 新增其它组件时若它被挤到非末尾位置，则把它移到最后。
     */
    ensureFloatingAtEnd: function ensureFloatingAtEnd() {
      var idx = this.pageComponents.findIndex(function (c) {
        return c.type === '1-10';
      });
      if (idx === -1 || idx === this.pageComponents.length - 1) return;
      var _this$pageComponents$ = this.pageComponents.splice(idx, 1),
        _this$pageComponents$2 = (0, _slicedToArray2.default)(_this$pageComponents$, 1),
        floating = _this$pageComponents$2[0];
      this.pageComponents.push(floating);
      /* 同步当前选中索引（this.index 指向本次新插入的组件） */
      if (this.index > idx) this.index = this.index - 1;
    },
    /**
     * 当拖动的元素或文本选择离开有效的放置目标时，会触发此事件
     *
     * @param {Object} event event对象
     */
    dragleaves: function dragleaves() {
      /* 删除提示组件 */
      this.pageComponents = this.pageComponents.filter(function (res) {
        return res.component !== 'placementarea';
      });
    },
    /**
     * 切换组件位置
     *
     * @param {Object} res 组件切换后返回的位置
     */
    componenmanagement: function componenmanagement(res) {
      this.pageComponents = res;
    },
    /**
     * 选择组件
     *
     * @param {Object} res 当前组件对象
     */
    activeComponent: function activeComponent(res, index) {
      this.index = index;
      /* 切换组件 */
      this.rightcom = res.style;
      /* 丢样式 */
      this.currentproperties = res.setStyle;
      /* 同步标题给右侧面板 */
      this.title = res.text;

      /* 替换 */
      _zdyPage.default.forEach(this.pageComponents, function (res) {
        /* 修改选中 */
        if (res.active === true) res.active = false;
      });

      /* 选中样式 */
      res.active = true;
    },
    /**
     * 标题切换
     *
     * @param {Object} res 当前组件对象
     */
    headTop: function headTop() {
      this.rightcom = 'decorate';
      this.title = '页面设置';

      /* 替换 */
      _zdyPage.default.forEach(this.pageComponents, function (res) {
        /* 修改选中 */
        if (res.active === true) res.active = false;
      });
    },
    /* 删除组件 */deleteObj: function deleteObj(index) {
      this.pageComponents.splice(index, 1);
      if (this.index === index) this.rightcom = 'decorate';
      if (index < this.index) this.index = this.index - 1;
    }
  }
};